// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2BP0z","filesListContainer":"PosDisputesFiles_filesListContainer__2fn4y","filesButton":"PosDisputesFiles_filesButton__1_7if"};